exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.am-select-range[data-v-826d5d3a] {\n  width: 450px;\n  background-color: whitesmoke;\n  overflow: hidden;\n}\n.am-select-range-header[data-v-826d5d3a] {\n  height: 35px;\n  background-color: #428bca;\n  padding: 10px;\n  top: 0;\n  color: white;\n  font-weight: 700;\n}\n.am-blue-border[data-v-826d5d3a] {\n  display: block;\n  width: 100%;\n  border-top: 1px solid #4297d7;\n  margin-top: 10px;\n}\n.am-buttons[data-v-826d5d3a] {\n  bottom: 0;\n  padding: 9px 7px 10px 0px;\n  float: right;\n}\n.am-select-range-content[data-v-826d5d3a] {\n  padding: 20px;\n  height: 60px;\n}\n", ""]);

// exports
